import React, { useState, useEffect } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  // Checkbox,
  IconButton,
  Typography,
  TextField,
  Button,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  // FormControl,
  // InputLabel,
  // Select,
  // MenuItem,
  Alert,
  CircularProgress,
  Tooltip,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import {
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Search as SearchIcon,
  Label as LabelIcon,
  FilterList as FilterIcon,
} from "@mui/icons-material";
import TagViewModel from "../viewmodels/TagViewModel";
import CreateTagDialog from "../components/CreateTagDialog";
import TagService from "../services/TagService";
import LabelOutlinedIcon from "@mui/icons-material/LabelOutlined";

const SORT_OPTIONS = [
  {
    key: "newest",
    label: "Created (Newest)",
    sortBy: "created_at",
    sortOrder: "desc",
  },
  {
    key: "oldest",
    label: "Created (Oldest)",
    sortBy: "created_at",
    sortOrder: "asc",
  },
];

const TagListView = () => {
  const [tagViewModel] = useState(() => new TagViewModel());
  const [state, setState] = useState({
    tags: [],
    filteredTags: [],
    searchQuery: "",
    selectedTags: [],
    isLoading: false,
    error: null,
  });
  const [tags, setTags] = useState([]);
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [editingTag, setEditingTag] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [tagToDelete, setTagToDelete] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [sortBy, setSortBy] = useState(SORT_OPTIONS[0].sortBy);
  const [sortOrder, setSortOrder] = useState(SORT_OPTIONS[0].sortOrder);
  const [sortKey, setSortKey] = useState("newest");

  useEffect(() => {
    const updateState = () => {
      setState(tagViewModel.state);
    };

    updateState();
    tagViewModel.onStateChange = updateState;

    return () => {
      tagViewModel.onStateChange = null;
    };
  }, [tagViewModel]);

  function fetch() {
    setLoading(true);
    TagService.getAllTags({
      search: searchQuery?.trim(),
      sortBy: sortBy,
      sortOrder: sortOrder,
    }).then((res) => {
      setTags(res);
      setLoading(false);
    });
  }

  useEffect(() => {
    fetch();
  }, []);

  useEffect(() => {
    fetch();
  }, [searchQuery?.trim(), sortBy, sortOrder]);

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleSelectTag = (tagId) => {
    tagViewModel.selectTag(tagId);
  };

  const handleSelectAll = () => {
    if (
      (state.selectedTags?.length || 0) === (state.filteredTags?.length || 0)
    ) {
      tagViewModel.deselectAllTags();
    } else {
      tagViewModel.selectAllTags();
    }
  };

  const handleDeleteTag = (tag) => {
    setTagToDelete(tag);
    setDeleteDialogOpen(true);
  };

  const confirmDeleteTag = () => {
    if (tagToDelete) {
      tagViewModel.deleteTag(tagToDelete.id);
    }
    setDeleteDialogOpen(false);
    setTagToDelete(null);
  };

  const handleEditTag = (tag) => {
    setEditingTag(tag);
    setIsEditDialogOpen(true);
  };

  const handleCreateTag = () => {
    setIsCreateDialogOpen(true);
  };

  const handleTagCreated = (newTag) => {
    fetch();
    setIsCreateDialogOpen(false);
  };

  const handleTagUpdated = (updatedTag) => {
    fetch();
    setIsEditDialogOpen(false);
    setEditingTag(null);
  };

  const getColorName = (color) => {
    const colorMap = {
      "#f44336": "Red",
      "#e91e63": "Pink",
      "#9c27b0": "Purple",
      "#673ab7": "Deep Purple",
      "#3f51b5": "Indigo",
      "#2196f3": "Blue",
      "#03a9f4": "Light Blue",
      "#00bcd4": "Cyan",
      "#009688": "Teal",
      "#4caf50": "Green",
      "#8bc34a": "Light Green",
      "#cddc39": "Lime",
      "#ffeb3b": "Yellow",
      "#ffc107": "Amber",
      "#ff9800": "Orange",
      "#ff5722": "Deep Orange",
      "#795548": "Brown",
      "#9e9e9e": "Grey",
      "#607d8b": "Blue Grey",
    };
    return colorMap[color] || "Custom";
  };

  return (
    <Box
      sx={{ p: 3, height: "100%", display: "flex", flexDirection: "column" }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          // borderBottom: "1px solid #e0e0e0",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <TextField
            placeholder="Search Tags"
            value={searchQuery}
            onChange={handleSearchChange}
            InputProps={{
              startAdornment: <SearchIcon sx={{ color: "#666", mr: 1 }} />,
            }}
            sx={{
              width: 300,
              "& .MuiOutlinedInput-root": {
                borderRadius: 2,
                backgroundColor: "#f8f9fa",
              },
            }}
            size="small"
          />
          {/* {state?.tags && (
          <Typography variant="body2" color="text.secondary" sx={{ fontFamily: 'Poppins, sans-serif' }}>
            {(state.filteredTags?.length || 0)} of {(state.tags?.length || 0)} tags
          </Typography>
        )} */}
        </Box>
        <Box sx={{ display: "flex", gap: 3 }}>
          <FormControl size="small" sx={{ minWidth: 200 }}>
            <Select
              value={sortKey}
              // IconComponent={SortIcon}
              displayEmpty
              onChange={(e) => {
                const selected = SORT_OPTIONS.find(
                  (opt) => opt.key === e.target.value,
                );
                setSortKey(selected.key);
                setSortBy(selected.sortBy);
                setSortOrder(selected.sortOrder);
              }}
              startAdornment={
                <FilterIcon sx={{ color: "#9e9e9e", mr: 0.5, fontSize: 18 }} />
              }
              sx={{
                borderRadius: 1.5,
                backgroundColor: "#fafafa",
                border: "1px solid #e0e0e0",
                fontSize: "0.875rem",
                "&:hover": {
                  backgroundColor: "#f5f5f5",
                  borderColor: "#d0d0d0",
                },
                "&.Mui-focused": {
                  backgroundColor: "#fff",
                  borderColor: "#1976d2",
                  boxShadow: "0 0 0 2px rgba(25, 118, 210, 0.1)",
                },
                "& fieldset": {
                  border: "none",
                },
                "& .MuiSelect-select": {
                  paddingLeft: 0.5,
                },
              }}
            >
              {SORT_OPTIONS.map((option) => (
                <MenuItem key={option.key} value={option.key}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleCreateTag}
            sx={{
              backgroundColor: "#1976d2",
              "&:hover": { backgroundColor: "#1565c0" },
              borderRadius: 2,
              px: 3,
              py: 1,
            }}
          >
            Add Tag
          </Button>
        </Box>
      </Box>
      {loading && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
        >
          <CircularProgress />
        </Box>
      )}
      {/* Search and Stats */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        {(state.selectedTags?.length || 0) > 0 && (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography variant="body2" color="text.secondary">
              {state.selectedTags.length} selected
            </Typography>
            <Button
              variant="outlined"
              color="error"
              size="small"
              startIcon={<DeleteIcon />}
              onClick={() => setDeleteDialogOpen(true)}
            >
              Delete Selected
            </Button>
          </Box>
        )}
      </Box>

      {/* Error Alert */}
      {state.error && (
        <Alert
          severity="error"
          sx={{ mb: 2 }}
          onClose={tagViewModel.clearError}
        >
          {state.error}
        </Alert>
      )}
      {/* ===== EMPTY TAGS PLACEHOLDER ===== */}
      {!loading && (tags?.length || 0) === 0 && (
        <Box
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            textAlign: "center",
            color: "#9ca3af",
            py: 6,
          }}
        >
          <LabelOutlinedIcon sx={{ fontSize: 72, mb: 1.5 }} />

          <Typography
            sx={{
              fontSize: 18,
              fontWeight: 600,
              mb: 0.5,
              fontFamily: "Poppins, sans-serif",
              color: "#374151",
            }}
          >
            No Tags Found
          </Typography>

          <Typography
            sx={{
              fontSize: 14,
              maxWidth: 320,
              fontFamily: "Poppins, sans-serif",
            }}
          >
            Create tags to organize and filter your contacts easily
          </Typography>

          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleCreateTag}
            sx={{ mt: 2, borderRadius: 2, textTransform: "none" }}
          >
            Add Tag
          </Button>
        </Box>
      )}

      {/* Tags Table */}
      {!loading && (tags?.length || 0) > 0 && (
        <Paper
          sx={{
            flex: 1,
            overflow: "hidden",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            borderRadius: 2,
          }}
        >
          <TableContainer sx={{ height: "100%" }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox">
                    {/* <Checkbox
                    checked={
                      (state.filteredTags?.length || 0) > 0 &&
                      (state.selectedTags?.length || 0) === (state.filteredTags?.length || 0)
                    }
                    indeterminate={
                      (state.selectedTags?.length || 0) > 0 &&
                      (state.selectedTags?.length || 0) < (state.filteredTags?.length || 0)
                    }
                    onChange={handleSelectAll}
                  /> */}
                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: 600, fontFamily: "Poppins, sans-serif" }}
                  >
                    Tag Name
                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: 600, fontFamily: "Poppins, sans-serif" }}
                  >
                    Color
                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: 600, fontFamily: "Poppins, sans-serif" }}
                  >
                    Description
                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: 600, fontFamily: "Poppins, sans-serif" }}
                  >
                    Contacts
                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: 600, fontFamily: "Poppins, sans-serif" }}
                  >
                    Created
                  </TableCell>
                  <TableCell
                    sx={{ fontWeight: 600, fontFamily: "Poppins, sans-serif" }}
                  >
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tags?.map((tag) => (
                  <TableRow
                    key={tag.getId()}
                    hover
                    sx={{
                      "&:hover": { backgroundColor: "#f8f9fa" },
                    }}
                  >
                    <TableCell padding="checkbox">
                      {/* <Checkbox
                      checked={(state.selectedTags || []).includes(tag.getId())}
                      onChange={() => handleSelectTag(tag.getId())}
                    /> */}
                    </TableCell>
                    <TableCell>
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <Chip
                          label={tag.getName()}
                          size="small"
                          sx={{
                            backgroundColor: tag.getColor(),
                            color: "white",
                            fontWeight: 500,
                            fontFamily: "Poppins, sans-serif",
                          }}
                        />
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <Box
                          sx={{
                            width: 20,
                            height: 20,
                            borderRadius: "50%",
                            backgroundColor: tag.getColor(),
                            border: "2px solid #e0e0e0",
                            fontFamily: "Poppins, sans-serif",
                          }}
                        />
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{ fontFamily: "Poppins, sans-serif" }}
                        >
                          {getColorName(tag.getColor())}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ fontFamily: "Poppins, sans-serif" }}
                      >
                        {tag.getDescription() || "No description"}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Chip
                        label={tag.getContactsCount()}
                        size="small"
                        variant="outlined"
                        sx={{
                          fontWeight: 500,
                          fontFamily: "Poppins, sans-serif",
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ fontFamily: "Poppins, sans-serif" }}
                      >
                        {new Date(tag.getCreatedAt()).toLocaleDateString()}
                      </Typography>
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: "flex", gap: 1 }}>
                        <Tooltip title="Edit Tag">
                          <IconButton
                            size="small"
                            onClick={() => handleEditTag(tag)}
                            sx={{ color: "#1976d2" }}
                          >
                            <EditIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete Tag">
                          <IconButton
                            size="small"
                            onClick={() => handleDeleteTag(tag)}
                            sx={{ color: "#f44336" }}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      )}
      {/* Create Tag Dialog */}
      <CreateTagDialog
        open={isCreateDialogOpen}
        onClose={() => setIsCreateDialogOpen(false)}
        onTagCreated={handleTagCreated}
        tagViewModel={tagViewModel}
      />

      {/* Edit Tag Dialog */}
      {editingTag && (
        <CreateTagDialog
          open={isEditDialogOpen}
          onClose={() => setIsEditDialogOpen(false)}
          onTagCreated={handleTagUpdated}
          tagViewModel={tagViewModel}
          editingTag={editingTag}
        />
      )}

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={deleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
      >
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <Typography>
            {tagToDelete
              ? `Are you sure you want to delete the tag "${tagToDelete.name}"?`
              : `Are you sure you want to delete ${state.selectedTags?.length || 0} selected tags?`}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)}>Cancel</Button>
          <Button onClick={confirmDeleteTag} color="error" variant="contained">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default TagListView;
